// RegistrationContext.jsx
import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
  useEffect,
} from 'react';

const RegistrationContext = createContext(null);

export function RegistrationProvider({ children }) {
  const [userInfo, setUserInfo] = useState(null);
  const [consultationInfo, setConsultationInfo] = useState(null);
  const [paymentInfo, setPaymentInfo] = useState(null);

  // Log on state changes
  // useEffect(() => {
  //   console.log('userInfo', userInfo);
  // }, [userInfo]);

  // useEffect(() => {
  //   console.log('consultationInfo', consultationInfo);
  // }, [consultationInfo]);

  // useEffect(() => {
  //   console.log('paymentInfo', paymentInfo);
  // }, [paymentInfo]);

  // Expose snapshot for debugging
  useEffect(() => {
    const snapshot = { userInfo, consultationInfo, paymentInfo };
    if (typeof window !== 'undefined') {
      window.__registrationCtx = snapshot;
    }
  }, [userInfo, consultationInfo, paymentInfo]);

  const value = useMemo(
    () => ({
      userInfo,
      setUserInfo,
      consultationInfo,
      setConsultationInfo,
      paymentInfo,
      setPaymentInfo,
    }),
    [userInfo, consultationInfo, paymentInfo],
  );

  return <RegistrationContext.Provider value={value}>{children}</RegistrationContext.Provider>;
}

export const useRegistration = () => {
  const ctx = useContext(RegistrationContext);
  if (!ctx) throw new Error('useRegistration must be used within RegistrationProvider');
  return ctx;
};
